(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page-trade"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function(event) {
    var input = event.target;
    if (!input.matches('.iy-file input[type="file"]')) return;
    var label = input.closest('.iy-file').querySelector('[data-iy-file-label]');
    if (!label) return;
    label.textContent = input.files && input.files.length ? input.files[0].name : label.textContent;
  });

  } catch(e) { console.error(e); }
})();
})();
